// @flow strict

import * as React from 'react';
import Icon from '@ta/core-ui.icon';
import classNames from '@ta/common.classnames';
import ManagedTextInput, { type Props as ManagedTextInputProps } from './ManagedTextInput';
import styles from './SearchTextInput.css';

/**
 * This is a version of ManagedTextInput that uses standard TA styling and a magnifying glass
 */
const SearchTextInput = ({ className, ...otherProps }: ManagedTextInputProps) => (
  <div className={classNames(styles.wrapper, className)}>
    <span className={styles.icon}>
      <Icon name="search" />
    </span>
    <ManagedTextInput className={styles.input} {...otherProps} />
  </div>
);

export default SearchTextInput;
